export const keywordsZh = {
  home: ['跨境网络服务', '跨境电商网络', 'TikTok运营网络', '海外AI工具', '一键连'],
  pricing: ['跨境网络套餐', '企业订阅计划', '月付套餐', '多设备支持', '跨境业务节点'],
  features: ['跨境网络功能', 'TikTok运营', 'Shopify访问', 'ChatGPT访问', '海外AI工具'],
  download: ['NodeUnion下载', '跨境客户端', 'Windows客户端', 'Mac客户端', 'Android客户端'],
  downloadWindows: ['Windows跨境客户端', 'PC跨境网络', 'NodeUnion Windows', '跨境电商PC'],
  downloadMacos: ['Mac跨境客户端', 'macOS跨境网络', 'NodeUnion Mac', 'Apple Silicon'],
  downloadAndroid: ['Android跨境客户端', '手机跨境网络', 'NodeUnion APK', 'TikTok手机运营'],
  downloadIos: ['iOS跨境网络', 'iPhone跨境业务', '移动端跨境服务'],
  help: ['跨境网络教程', 'NodeUnion配置', 'TikTok运营指南', '海外AI工具访问'],
  about: ['关于一键连', '跨境网络服务商', '全球业务网络'],
  privacy: ['隐私政策', '数据保护', '无日志政策'],
  terms: ['服务条款', '使用规范', '退款说明'],
} as const;

export const keywordsEn = {
  home: ['cross-border network service', 'cross-border e-commerce', 'TikTok operations', 'overseas AI tools'],
  pricing: ['cross-border network plans', 'subscription pricing', 'business plans', 'multi-device'],
  features: ['cross-border features', 'TikTok network', 'Shopify access', 'ChatGPT access', 'overseas AI'],
  download: ['NodeUnion download', 'cross-border client', 'Windows client', 'Mac client', 'Android client'],
  downloadWindows: ['Windows cross-border client', 'PC global commerce', 'NodeUnion Windows'],
  downloadMacos: ['Mac cross-border client', 'macOS global network', 'NodeUnion Mac'],
  downloadAndroid: ['Android cross-border client', 'mobile TikTok ops', 'NodeUnion APK'],
  downloadIos: ['iOS cross-border network', 'iPhone business network'],
  help: ['setup guide', 'NodeUnion config', 'TikTok guide', 'overseas AI access'],
  about: ['about us', 'cross-border network provider', 'global business network'],
  privacy: ['privacy policy', 'no logs policy', 'data protection'],
  terms: ['terms of service', 'usage policy', 'refund policy'],
} as const;
